export const PERIOD_TYPE = {
  DATE_REG: 0,
  DATE_BEG: 1,
  DATE_END: 2,
  DATE_VIPISKA: 3,
  EXECUTOR_DAY: 4
};

export const PERIOD_TYPE_OPTIONS = [
  { value: PERIOD_TYPE.DATE_REG, label: "Регистрации" },
  { value: PERIOD_TYPE.DATE_BEG, label: "Заезда" },
  { value: PERIOD_TYPE.DATE_END, label: "Выезда" },
  { value: PERIOD_TYPE.DATE_VIPISKA, label: "Выписки" },
  { value: PERIOD_TYPE.EXECUTOR_DAY, label: "По исполнителю" }
];

export const STAY_STATUS = {
  ALL: "all",
  IN: "in"
};

export const STAY_STATUS_OPTIONS = [
  { value: STAY_STATUS.ALL, label: "Все" },
  { value: STAY_STATUS.IN, label: "В санатории" }
];

export const GRID_STORAGE_KEY = "planOnline.health.clients.grid.v3";

export const DEFAULT_HIDDEN_COLUMN_KEYS = [
  "isPred",
  "isOk",
  "extraId",
  "dateReg",
  "days",
  "dateVipiska",
  "komment",
  "visit",
  "daysFact",
  "keyCardShort",
  "deposit",
  "isNotSk",
  "osnTxt",
  "age",
  "idDoc",
  "idStr",
  "tovName",
  "factIsOk",
  "zalName",
  "nameLech",
  "ssgName",
  "dDateBeg",
  "dDateEnd"
];

export const defaultFilters = () => ({
  periodType: PERIOD_TYPE.DATE_REG,
  dateBeg: null,
  dateEnd: null,
  onlyInComplex: false,
  idSotr: 0,
  name: ""
});
